import { render, staticRenderFns } from "./FilterRolesResponsibilitiesModal.vue?vue&type=template&id=66d46078&scoped=true"
import script from "./FilterRolesResponsibilitiesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterRolesResponsibilitiesModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FilterRolesResponsibilitiesModal.vue?vue&type=style&index=0&id=66d46078&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d46078",
  null
  
)

export default component.exports